import { UserFromGetOne } from '@/models/user';

export const groupMemberships = (roles: UserFromGetOne['roles']) => {
  const rowsByKey = new Map<
    string,
    {
      entity: { id: string; name: string } | null;
      roles: { id: string; name: string }[];
    }
  >();

  for (const userRole of roles) {
    const key = userRole.entityId ?? `org-${userRole.organizationId}`;

    if (!rowsByKey.has(key)) {
      rowsByKey.set(key, {
        entity: userRole.entity ? { id: userRole.entity.id, name: userRole.entity.name } : null,
        roles: [],
      });
    }

    const row = rowsByKey.get(key)!;
    const roleAlreadyAdded = row.roles.some((role) => role.id === userRole.role.id);

    if (!roleAlreadyAdded) {
      row.roles.push({ id: userRole.role.id, name: userRole.role.name });
    }
  }

  return Array.from(rowsByKey.values()).sort((a, b) => {
    const nameA = a.entity?.name ?? '';
    const nameB = b.entity?.name ?? '';

    return nameA.localeCompare(nameB);
  });
};
